import { Stack, Typography } from '@mui/material';
import IconFontAwesome from 'new/components/IconFontAwesome';

import useActiveOffice from 'new/hooks/useActiveOffice';
import { getNumberWithOrdinal } from 'new/utils/numbers';
import { Link } from 'react-router';
import findRoute from 'new/routing/routes';
import { usePageClick } from 'new/hooks/usePageClick';
import { useUserLeaderboard } from '../hooks';

const LeaderboardIcon = () => {
  let currentScore = 0;
  let rank = 0;
  const { user } = useActiveOffice();
  const { data } = useUserLeaderboard(user?.data.dentistInfo.id);
  const { mutate: logClick } = usePageClick();

  const { getPath } = findRoute('SeasonOfGivingPage');
  const seasonOfGivingPath = getPath ? getPath() : '';

  if (data) {
    currentScore = data.currentScore;
    rank = data.rank;
  }

  return (
    <Link
      to={seasonOfGivingPath}
      onClick={() => {
        logClick({
          dentistInfoId: user?.data.dentistInfo.id,
          clickEvent: 'Leaderboard Sidebar Click',
        });
      }}
    >
      <Stack alignItems="center" mr={2}>
        <IconFontAwesome name="faRankingStar" size="2x" color="animated" />
        {!!currentScore && !!rank && (
          <Typography
            fontSize="0.875rem"
            fontWeight="bold"
            color="success.main"
          >
            {getNumberWithOrdinal(rank)}
          </Typography>
        )}
      </Stack>
    </Link>
  );
};

export default LeaderboardIcon;
